import {Model} from "@/store/models/model";
import {Country} from "@/store/models/country";
import axios from '@/store/vue-axios'
import {UserConfigDefaults} from "@/store/models/layout/user_config";

export class User extends Model {

  // static apiEntity = 'user' // DO NOT WORK WITH DATATABLE
  static entity = 'users'
  static primaryKey = 'username'


  /**
   * @returns {{email_tech: String, country: BelongsTo, parent: BelongsTo, gender: String, city: String, created_at: String, type: String, number: String, street: String, credit_limit: Number, next_billing_circle: String, company: String, id: Attr, state: String, fax: String, first_name: String, email: String, zip: String, amount: Number, email_abuse: String, last_name: String, country_code: String, phone: String, email_accounting: String, parent_id: String, position: String, email_newsletter: String, email_contact: String, username: String}}
   */
  static fields() {
    return {
      id: this.attr(null),
      username: this.string(''),
      company: this.attr(null),
      gender: this.attr(null),
      first_name: this.attr(null),
      last_name: this.attr(null),
      position: this.attr(null),

      email: this.attr(null),
      email_tech: this.attr(null),
      email_contact: this.attr(null),
      email_accounting: this.attr(null),
      email_newsletter: this.attr(null),
      email_abuse: this.attr(null),

      street: this.attr(null),
      number: this.attr(null),
      zip: this.attr(null),
      city: this.attr(null),
      country_code: this.attr(null),
      phone: this.attr(null),
      fax: this.attr(null),

      credit_limit: this.number(0),
      amount: this.number(0),
      next_billing_circle: this.string(''),

      type: this.string(''),
      state: this.string(''),
      parent_id: this.attr(null),
      created_at: this.string(''),

      //Relations
      country: this.belongsTo(Country, 'country_code'),
      parent: this.belongsTo(User, 'parent_id')
    }
  }

  static async fetch(username) {
    if (!username)
      return
    console.log('CURRENT USER STATUS', username)
    const conf = UserConfigDefaults.getConfigs(username)
    const response = await axios.get('/account/users/' + username)
    User.insertOrUpdate({data: response.data.user})
    return User.find(username)
  }

  static currentUser() {
    let username = localStorage.getItem("currentUser")
    if ( !username ) {
      const result = axios.get('/account/account')
      result.then((item) => {
        localStorage.setItem("currentUser", item.data.user.username)
      }).catch(error=>error)
      username = result.data.user.username

    }

    return User.find(username) || User.fetch(username)
  }
}

export default User



// WEBPACK FOOTER //
// ./src/store/models/user.js